module.exports = __webpack_public_path__ + "img/Stihl.27d3fc5f.png";